import { baseURL } from '../../../axios/axios';

/**
 * 导出 Word：GET /ai/paper/editor/v2/export?orderNo=…，直接下载后端返回的 docx
 */
export const exportWord = async (orderNo) => {
    if (!orderNo) throw new Error('订单号不存在，无法导出');

    const url = `${baseURL}ai/ai/paper/editor/v2/export?orderNo=${encodeURIComponent(orderNo)}`;
    const response = await fetch(url, { method: 'GET' });
    if (!response.ok) {
        throw new Error(`导出失败（${response.status}）`);
    }

    let filename = `论文_${orderNo}.docx`;
    const disposition = response.headers.get('Content-Disposition');
    if (disposition) {
        const match =
            disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i) ||
            disposition.match(/filename="?([^";\n]+)"?/i);
        if (match && match[1]) {
            try {
                filename = decodeURIComponent(match[1].trim());
            } catch (error) {
                filename = match[1].trim();
            }
        }
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
    return filename;
};
